import getCalendarSearchStore, { defaultCalendarSearchStoreData } from '../store/store';
import { mutator } from 'satcheljs';
import { resetSearchStore } from '../actions/searchStoreActions';

export let resetSearchStoreMutator = mutator(resetSearchStore, () => {
    let searchStore = getCalendarSearchStore();

    searchStore.fromDate = defaultCalendarSearchStoreData.fromDate;
    searchStore.toDate = defaultCalendarSearchStoreData.toDate;
    searchStore.includeAttachments = defaultCalendarSearchStoreData.includeAttachments;
    searchStore.calendarFoldersScope = defaultCalendarSearchStoreData.calendarFoldersScope;
    searchStore.selectedCalendarsCount = defaultCalendarSearchStoreData.selectedCalendarsCount;
    searchStore.searchNumber = defaultCalendarSearchStoreData.searchNumber;
    searchStore.accountSmtpAddress = null;

    // End the last datapoint if the user exited search before completing the search.
    // If the datapoint has already ended (normal scenario), then this will be a no-op
    if (searchStore.searchEndToEndDatapoints && searchStore.searchEndToEndDatapoints.length > 0) {
        let lastDatapoint =
            searchStore.searchEndToEndDatapoints[searchStore.searchEndToEndDatapoints.length - 1];

        lastDatapoint.addCustomData({
            isCancelled: true,
        });

        lastDatapoint.end();
    }

    searchStore.searchEndToEndDatapoints = defaultCalendarSearchStoreData.searchEndToEndDatapoints;
    searchStore.refinersVisible = defaultCalendarSearchStoreData.refinersVisible;
});
